import React from "react";

import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { getHome } from "../../MyApi/core/home";

import Statistics from "../../Components/home/statistics";
import InfoRow from "../../Components/home/InfoRow";
import LoadingSpinner from "../../Components/UI/spinner";
import LineChartClass from "../../Components/home/chart/apexChart";
import DoughnutChartClass from "../../Components/home/chart/dounghtChart";
import TasksCard from "../../Components/home/tasksCard";
import NoData from "../../Components/UI/nodata";

const Home = () => {
  const { data, isLoading } = useQuery("getHome", getHome);
  const { t } = useTranslation();
  const statics = data || {};
  if (isLoading) {
    return <LoadingSpinner />;
  }
  const responeMessage =data?.message
 if(Object.keys(statics).length === 0){
  return <NoData responeMessage={responeMessage} />
 }
  if (!data) {
    return <div>no data available</div>;
  }

  return (
    <div>
      <Statistics statics={statics} />
      <div className="row">
        <LineChartClass statics={statics} />
      </div>
      <div className="row">
        <DoughnutChartClass statics={statics} />
        <TasksCard />
      </div>
      <InfoRow />
    </div>
  );
};

export default Home;
